import React from 'react'
import { Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
import { Box, LazyImage, SpanStyled } from '../Elements'
import { FooterBg, FooterLogo, Instagram, Snapchat, Tiktok } from '../AllImages'
import { NavDataConfig } from '../../components/projectData/Data'
import { Link } from 'react-scroll'
import { useTranslation } from 'react-i18next'
import ChangeButton from '../../Languages/ChangeButton'

const certificateItems = [
    {
        pdf: '/certificates/tourism-license.pdf',
        labelKey: 'Licence_Tourism',
        numberKey: 'Licence_Tourism_No',
    },
    {
        pdf: '/certificates/tax-certificate.pdf',
        labelKey: 'Licence_Tax',
        numberKey: 'Licence_Tax_No',
    },
    {
        pdf: '/certificates/commercial-register.pdf',
        labelKey: 'Licence_Commercial',
        numberKey: 'Licence_Commercial_No',
    },
]

const Footer = () => {
    const { t } = useTranslation();
    const date_year = new Date();
    const SocialLinkTiktok = () => {
        window.open('https://www.tiktok.com/@skyworld_7?_t=8hdTgbvV7CC&_r=1', '_blank');
    };
    const SocialLinkSnapchat = () => {
        window.open('https://www.snapchat.com/add/sahab-alalam', '_blank');
    };
    const SocialLinkInstagram = () => {
        window.open('https://instagram.com/sahabalalam.sa?igshid=NGVhN2U2NjQ0Yg==', '_blank');
    };
    return (
        <FooterWapper className='container-fluid footerFluid'>
            <Box className='footer-BG'>
                <LazyImage className='footer-vector-img' src={FooterBg} />
            </Box>
            <Container>
                <Row>
                    <Box className='footerContentContainer'>
                        <Box className='footerLogo'>
                            <LazyImage src={FooterLogo} />
                        </Box>

                        <Box className='Footer-social-links'>
                            <Box className='d-flex align-items-center gap-3 mb-3 socialLinksContainer'>
                                <Box className='socialLinks'><Tiktok onClick={SocialLinkTiktok} /></Box>
                                <Box className='socialLinks'><Snapchat onClick={SocialLinkSnapchat} /></Box>
                                <Box className='socialLinks'><Instagram onClick={SocialLinkInstagram} /></Box>
                            </Box>
                            <Box className='footerBottomRow'>
                                <Box className='d-flex flex-column footer-list-container'>
                                    <Box className='footer-list'>
                                        {NavDataConfig.map((item, key) => (
                                            <Box key={key}>
                                                <Link to={item.to} spy={true} smooth={true} offset={-60} duration={500} >{t(item.label)} </Link>
                                            </Box>
                                        ))}
                                    </Box>
                                    <SpanStyled className='copyRightDes mt-2' size='13px' color='var(--themeColor)' transform='capitalize'>&copy; {date_year.getFullYear()} {t('All_Rights_Reserved')}</SpanStyled>
                                </Box>
                                <Box className='footerCertificates'>
                                    <SpanStyled className='footerCertificatesTitle' size='20px' transform='capitalize' weight='bold'>
                                        {t('Licences_Certificates')}
                                    </SpanStyled>
                                    <Box className='footerCertificatesLogos'>
                                        {certificateItems.map((item) => (
                                            <a
                                                key={item.labelKey}
                                                href={item.pdf}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                className='footerCertificateLink'
                                            >
                                                {t(item.labelKey)} : {t(item.numberKey)}
                                            </a>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        
                    </Box>
                </Row>
            </Container>
            <ChangeButton />
        </FooterWapper>
    )
}
const FooterWapper = styled.footer`
    position:relative;
    padding: 0px 0 70px 0px;
    overflow: hidden;
    .container{
        position: relative;
        z-index: 2;
        padding-bottom: 70px !important;
    }
    .footer-BG{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        z-index: 1;
        pointer-events: none;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        line-height: 0;

        .footer-vector-img,
        .lazy-load-image-background,
        span,
        img{
            display: block;
            width: auto;
            max-width: 100%;
            height: auto;
            margin: 0;
            vertical-align: bottom;
        }
    }
    .footer-list{
        display:flex;  
        align-items: center;
        gap: 25px;
        & a{
            background: var(--gradientBlue);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-family: var(--medium);
            padding-bottom: 5px;
            
        }
    }
    .socialLinks{
        cursor: pointer;
    }
    .footerBottomRow{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 40px;
        flex-wrap: wrap;
    }
    .footerCertificates{
        position: relative;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
    .footerCertificatesTitle{
        display: block;
        white-space: nowrap;
        font-weight: bold;
        background: var(--gradientBlue);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    body.rtl & .footerCertificatesTitle{
        font-family: var(--arRegular);
    }
    .footerCertificatesLogos{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 20px;
    }
    .footerCertificateLink{
        display: block;
        color: var(--themeColor);
        font-family: var(--medium);
        font-size: 14px;
        text-decoration: none;
        white-space: nowrap;
        transition: opacity 0.2s ease;

        &:hover{
            opacity: 0.8;
            text-decoration: underline;
        }
    }
    body.rtl & .footerCertificateLink{
        font-family: var(--arRegular);
    }

    @media (max-width: 991px) {
        .footerBottomRow{
            flex-direction: column;
            align-items: center;
            gap: 24px;
        }
        .footerCertificates{
            align-items: center;
            text-align: center;
        }
        .footerCertificatesLogos{
            justify-content: center;
        }
    }

    @media (max-width: 575px) {
        padding-bottom: 40px;
        .container{
            padding-bottom: 40px !important;
        }
        .footerCertificatesLogos{
            gap: 10px 16px;
            justify-content: center;
        }
        .footerCertificateLink{
            font-size: 13px;
            white-space: normal;
        }
    }

`
export default Footer
